<template>
    <div v-if="loaded" class="form-items-container col-12 mt-2 pl-1 pr-1">
        <draggable v-model="rows" tag="div" class="row wrap fill-height align-center sortable-list" @change="onDraggableChange">
            <div v-for="(row, rowIndex) in rows" v-show="row.form_field_questions_with_files[0].show" :key="rowIndex" class="sortable d-flex w-100" :class="row.show ? '' : 'option-hidden'">
                <div class="question-container">
                    <div class="header">
                        <button class="btn destroy float-right p-0" @click.prevent="row.show = 0"><app-icon :name="'trash'" width="25" height="25" /></button>
                        <app-icon :name="'move'" width="25" height="25" class="handle-question mr-2" />
                        <div class="btn btn-primary btn-sm badge-counter mr-2 mb-3">{{ rowIndex+1 }}</div>
                        <strong class="header-title">{{ $t("form_question_headline") }}</strong>
                        
                        
                        <app-input id="inputs_name" class="name col-sm-12 p-0" :placeholder="$t('form_question')" type="textarea" v-model="row.form_field_questions_with_files[0].title" :required="true" />
                    </div>
                    <div class="row pl-3">
                        <div class="col-md-12 row pt-3 pb-1 float-right">
                            <div class="col-sm-6 col-md-3"><strong>{{ $t("form_answer_headline") }}</strong></div>
                            <div class="col-sm-6 col-md-9 answer-container">
                                <span @click.prevent="setType(rowIndex, 'radio')" :class="row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'radio' ? 'active' : ''" :title="$t('form_type_radio')">
                                    <app-icon :name="'check-square'" width="22" height="22" class="answer-type" /> {{ $t("form_type_radio") }}
                                </span>&nbsp;&nbsp;
                                <span @click.prevent="setType(rowIndex, 'text')" :class="row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'text' ? 'active' : ''" :title="$t('form_type_text')">
                                    <app-icon :name="'message-square'" width="22" height="22" class="answer-type" /> {{ $t("form_type_text") }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <draggable :list="row.form_field_questions_with_files[0].form_field_answers_with_files" tag="div" :group="{ name: 'group-' + row.id }" class="wrap justify-space-around p-0" ghost-class="ghost" handle=".handle" @change="onDraggableChange">
                        <div v-for="(answer, answerIndex) in row.form_field_questions_with_files[0].form_field_answers_with_files" :key="answerIndex" class="option" :class="!answer.show || (row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'text' && answerIndex > 0) ? 'option-hidden' : ''">
                            <div class="col-sm-1 col-move">
                                <app-icon :name="'move'" width="25" height="25" class="float-right handle" />
                            </div>

                            <div class="col-sm-7">
                                <app-input class="name" :placeholder="row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'text' ? $t('answer_text_placeholder') : $t('answer_placeholder')" v-model="answer.title" type="textarea" style="min-height:74px;" :required="true" />
                            </div>

                            <div class="col-sm-2 answer" v-if="answer.correct == 1 && row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'radio'">
                                <div class="questionnaire-mark questionnaire-mark-perfect"></div>
                            </div>
                            <div class="col-sm-2 answer cursor-pointer" v-else-if="answer.correct == 0 && row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'radio'" @click.prevent="setCorrectAnswer(rowIndex, answerIndex)" :title="$t('set_correct_answer')">
                                <div class="questionnaire-mark questionnaire-mark-wrong"></div>
                            </div>

                            <!-- @todo: až budou spustěné formuláře s možností checkbox -->
                            <!--
                  <app-input id="inputs_timeline_state"
                             class="large-input"
                             type="select"
                             :title="$t('timeline_state')"
                             v-model="answer.correct"
                             :list="answerResult"
                             :required="true"/>

                  <button  class="btn btn-primary btn-sm" >{{ $t('set_correct_answer') }}</button> -->

                            <button class="col-sm-1 btn destroy" @click.prevent="answer.show = 0"><app-icon :name="'trash'" width="20" height="20" /></button>
                        </div>
                    </draggable>
                    
                    <div v-if="row.form_field_questions_with_files[0].form_field_answers_with_files[0].type == 'radio'" class="option option-add w-100 d-flex col-xs-4">
                        <button class="btn btn-primary btn-sm" @click.prevent="addAnswer(rowIndex)">{{ $t("form_add_option") }}</button>
                    </div>

                    <div v-if="category == 'document'" class="footer row p-3">
                        <div class="col-md-1 pb-1">
                            <app-icon :name="'edit-3'" width="22" height="22" />
                        </div>
                        <div class="col-md-4 pb-1">
                            <strong> {{ $t('write_data_to') }} </strong>
                        </div>
                        <div class="col-md-3 pb-1">
                             {{ $t('candidate_fields') }}<br>
                            <app-input id="inputs_candidate_field_type" class="float-left w-100" :list="candidateFieldTypesList" type="select" v-model="row.form_field_questions_with_files[0].candidate_field_type" />
                        </div>
                        <div class="col-md-4 pb-1">
                            {{ $t('candidate_meta') }}<br>
                            <app-input id="inputs_candidate_meta_type_id" class="float-left w-100" :list="metaTypesList" type="select" v-model="row.form_field_questions_with_files[0].candidate_meta_type_id" />
                        </div>
                        
                    </div>
                </div>
            </div>
        </draggable>
        <div v-if="visibleRows" class="text-center text-muted"><strong>{{ $t("total") }} {{ visibleRows }} {{ $t("total_questions") }}<br> <a href="" @click.prevent="makeAllRowsVisible()">{{ hiddenRows }} </a></strong></div>
        <div class="w-100 text-center mt-4">
            <button class="btn btn-primary" @click.prevent="addRow(rows.length + 1)">+ {{ $t("form_add_question") }}</button>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    name: "Form",
    components: {
        draggable,
    },
    props: {
        initialRows: {
            required: false,
            type: [Array],
        },
        formCategory: {
            required: true,
            type: [String],
        },
    },
    watch: {
        rows: {
            immediate: true,
            deep: true,
            handler(val, oldVal) {
                let data = val;
                let defaultQuestions = [
                    {
                        id: null,
                        title: "",
                        candidate_meta_type_id: null,
                        candidate_field_type: null,
                        required: 1,
                        locale: "cz",
                        order: 1,
                        form_field_answers_with_files: [{ id: null, form_field_question_id: null, correct: 1, type: "radio", show: 1, title: "", locale: "cz", order: 1, files: [] }],
                    },
                ];

                // Do not emit if empty object on first run
                if(Array.isArray(data)){
                    let ensureNonEmptyFormFieldQuestions = (data, defaultQuestions) => {
                        data.forEach(item => {
                            if (item.form_field_questions_with_files.length === 0) {
                                item.form_field_questions_with_files = [...defaultQuestions];
                            }
                        });
                        return data;
                    };

                    let updatedData = ensureNonEmptyFormFieldQuestions(data, defaultQuestions);
                    if (oldVal) {
                        this.$emit("getFormData", JSON.stringify(updatedData));
                    }
                }
                
            },
        },
        formCategory: {
            immediate: true,
            deep: true,
            handler(val, oldVal) {
                this.category = val;
            },
        },
    },
    computed: {
        visibleRows() {
            let totalVisibleRows = 0;
            let visibleRows = this.rows.forEach((e, i) => {
                if (e.show == 1) {
                    totalVisibleRows++;
                }
            });
            return totalVisibleRows;
        },
        hiddenRows() {
            let totalHiddenRows = 0;
            let hiddenRows = this.rows.forEach((e, i) => {
                if (e.show == 0) {
                    totalHiddenRows++;
                }
            });

            let text = totalHiddenRows == 1 ? this.$t("deleted_question") : this.$t("deleted_questions");
            let response = totalHiddenRows > 0 ? this.$t("move_questions_from_trash")+" "+totalHiddenRows+" "+text : "";
            return response;
        }
    },
    data() {
        return {
            enabled: true,
            loaded: false,
            answerResult: [
                { id: 1, value: this.$t("correct") },
                { id: 0, value: this.$t("wrong") },
            ],
            optionsType: [
                { id: "radio", value: this.$t("form_radio") },
                //{id: 'checkbox', value: this.$t('form_checkbox')},
                //{id: 'textarea', value: this.$t('form_textarea')},
            ],
            metaTypesList: [
                { id: null, value: this.$t("choose...") },
                { id: 1, value: this.$t("meta_residence") },
                { id: 2, value: this.$t("meta_citizenship") },
                { id: 3, value: this.$t("meta_marital_status") },
                { id: 4, value: this.$t("meta_birthplace") },
                { id: 5, value: this.$t("meta_personal_identification_number") },
                { id: 6, value: this.$t("meta_insurance") },
                { id: 7, value: this.$t("meta_banking_account") },
                { id: 8, value: this.$t("meta_criminal_record") },
                { id: 9, value: this.$t("meta_street") },
                { id: 10, value: this.$t("meta_house_no") },
                { id: 11, value: this.$t("meta_postal_code") },
                { id: 12, value: this.$t("meta_city") },
                { id: 13, value: this.$t("meta_concurrent_employment") },
                { id: 14, value: this.$t("meta_student") },
                { id: 15, value: this.$t("meta_in_records_of_labor_office") },
                { id: 16, value: this.$t("meta_altered_work_capacity") },
                { id: 17, value: this.$t("meta_contract") },
                { id: 18, value: this.$t("meta_insolvency") },
                { id: 19, value: this.$t("meta_health_condition") },
                { id: 20, value: this.$t("meta_handicap") },
                { id: 21, value: this.$t("meta_foreclosure") },
                { id: 22, value: this.$t("meta_pension") },
                { id: 23, value: this.$t("meta_pension_type") },
                { id: 24, value: this.$t("meta_language") },
            ],
            candidateFieldTypesList: [
                { id: null, value: this.$t("choose...") },
                { id: "name", value: this.$t("name") },
                { id: "surname", value: this.$t("surname") },
                { id: "email", value: this.$t("email") },
                { id: "phone", value: this.$t("phone") },
                { id: "gender", value: this.$t("gender") },
                { id: "birthdate", value: this.$t("birthdate") },
                { id: "event_date", value: this.$t("onboarding_start_date") },
                { id: "linkedin", value: this.$t("linkedin") },
                { id: "source", value: this.$t("source") },
            ],
            selectedOptionType: "radio",
            rows: {},
        };
    },
    mounted() {
        this.rows = this.initialRows;
        this.category = this.formCategory;
        this.loaded = true;
    },
    methods: {
        /**
         * Actions
         * */

        addRow(order) {
            this.rows.push({
                id: null,
                files: [],
                order: order,
                show: 1,
                form_field_questions_with_files: [
                    {
                        id: null,
                        title: "",
                        candidate_meta_type_id: null,
                        candidate_field_type: null,
                        required: 1,
                        locale: "cz",
                        order: 1,
                        form_field_answers_with_files: [{ id: null, form_field_question_id: null, correct: 1, type: "radio", show: 1, title: "", locale: "cz", order: 1, files: [] }],
                    },
                ],
            });
        },
        setType(selectedRow, type) {
            this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files.forEach((e, i) => {
                this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files[i].type = type;
            });
        },
        setCorrectAnswer(selectedRow, selectedAnswer) {
            this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files.forEach((e, i) => {
                this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files[i].correct = 0;
            });
            this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files[selectedAnswer].correct = 1;
        },
        addAnswer(selectedRow) {
            let totalAnswers = this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files;

            this.rows[selectedRow].form_field_questions_with_files[0].form_field_answers_with_files.push({
                id: null,
                form_field_question_id: null,
                files: [],
                order: totalAnswers.length + 1,
                correct: 0,
                type: "radio",
                show: 1,
                title: "",
                locale: "cz",
            });
        },
        makeAllRowsVisible() {
            this.rows.forEach(item => {
                item.show = 1;
            });
        },
        onDraggableChange(event) {
            this.reorder();
        },
        reorder() {
            this.rows.forEach((row, index) => {
                row.order = index + 1;

                row.form_field_questions_with_files[0].form_field_answers_with_files.forEach((answer, answerIndex) => {
                    answer.order = answerIndex + 1;
                });
            });
        },

        /**
         * Get additional data
         * */
    },
};
</script>
<style scoped>
.buttons {
    margin-top: 35px;
}
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
